// extracted by mini-css-extract-plugin
export default {"logoWrapper":"confirmation_logoWrapper__9fjdX","formLabel":"confirmation_formLabel__DVsSu","formContainer":"confirmation_formContainer__Zh87f"};